

// components/common/ProgressBar.tsx
import React from 'react';

interface ProgressBarProps {
  progress: number;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  label?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ 
  progress, 
  color = 'blue', 
  size = 'md', 
  showLabel = false,
  label 
}) => {
  const heights = { sm: 'h-1', md: 'h-2', lg: 'h-3' };
  
  return (
    <div>
      {showLabel && (
        <div className="flex justify-between items-center mb-2 ">
          <span className="text-sm font-medium text-gray-700">{label}</span>
          <span className="text-sm text-gray-500">{progress}%</span>
        </div>
      )}
      <div className={`w-full bg-gray-200 rounded-full ${heights[size]}`}>
        <div
          className={`bg-${color}-500 ${heights[size]} rounded-full transition-all duration-300`}
          style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
        />
      </div>
    </div>
  );
};
